import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

interface PopoverActionsProps extends PropsWithChildren {
  className?: string;
}

export function PopoverActions(props: PopoverActionsProps) {
  const { className, children } = props;
  const combinedClassName = className
    ? `${styles.popoverActions} ${className}`
    : styles.popoverActions;

  return <div className={combinedClassName}>{children}</div>;
}

const styles = {
  popoverActions: css({
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-2)",
    paddingBottom: "var(--space-4)",
    paddingLeft: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingTop: "var(--space-1)",
  }),
};
